// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum PlayerTurnStatus {
  Waiting = 2,
  Pending = 3,
  Playing = 4,
  Done = 5
}
